import { ImageList, Stack, SxProps, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { ConnectedEntity } from "src/types/apps";

import CrossExitBtn from "../../components/CrossExitBtn";
import Context from "../../context";
import CardWrapper from "../CardWrapper";
import Powered from "../Powered";
import BackBtn from "./BackBtn";
import EntityItemBtn from "./EntityItemBtn";
import EntityItemMobile from "./EntityItemMobile";

// ----------------------------------------------------------------------

const defaultEntities: ConnectedEntity[] = [
	{
		id: "renta4",
		name: "Renta 4"
	},
	{
		id: "myinvestor",
		name: "MyInvestor"
	},
	{
		id: "bankinter",
		name: "Bankinter"
	},
	{
		id: "degiro",
		name: "Degiro"
	}
];

type Props = {
	sx?: SxProps;
	isSelected?: boolean;
};

export const EntitiesPanel = ({ sx, isSelected }: Props) => {
	const { values, state } = useContext(Context);
	const { translate } = useLocales();

	const isMobile = state.isMobile;

	const itemsList = () => {
		return defaultEntities.map((item) =>
			isMobile ? (
				<EntityItemMobile key={item.id} item={item} />
			) : (
				<EntityItemBtn key={item.id} item={item} />
			)
		);
	};

	return (
		<CardWrapper sx={sx} isSelected={isSelected}>
			<Stack sx={{ maxWidth: 800 }} width={isMobile ? 330 : "auto"} height={490}>
				<Stack flexDirection={"row"} alignItems={"center"}>
					<BackBtn />
					{values?.showExit && <CrossExitBtn />}
					<Typography
						variant='h6'
						alignSelf={{ xs: "center", sm: "flex-start" }}
						sx={{ ml: 2, mt: 0.3 }}
						color={values.primaryTextColor}
					>
						{translate("customization.select_entity")}
					</Typography>
				</Stack>

				<ImageList cols={isMobile ? 1 : 4} sx={{ mt: 2, pb: 2 }}>
					{itemsList()}
				</ImageList>
			</Stack>
			<Powered />
		</CardWrapper>
	);
};

export default EntitiesPanel;
